import React, { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { KeyboardShortcut, Key } from '@repo/components/tooltips';
import Button from './Button';

type GoBackProps = React.HTMLAttributes<HTMLDivElement> & {
  onGoBack?: (triggeredByClick?: boolean) => void;
};

export default function GoBack({ children, className, onGoBack }: GoBackProps) {
  const navigate = useNavigate();

  const goBack = useCallback(
    (triggeredByClick?: boolean) => {
      if (onGoBack) {
        return onGoBack(triggeredByClick);
      }

      navigate(-1);
    },
    [onGoBack, navigate],
  );

  const handleClick = useCallback(
    (e) => {
      e.preventDefault();
      goBack(true);
    },
    [goBack],
  );

  useEffect(() => {
    const handleHotkey = (e) => {
      if (!e.defaultPrevented && e.key == 'Escape') {
        goBack();
      }
    };

    window.app.on('hotkey', handleHotkey);
    return () => window.app.off('hotkey', handleHotkey);
  }, [goBack]);

  return (
    <KeyboardShortcut
      placement="bottom"
      shortcut={
        <>
          <Key>ESC</Key>Go Back
        </>
      }
    >
      <Button onClick={handleClick} className={className}>
        {children}
      </Button>
    </KeyboardShortcut>
  );
}
